import React, { Component,useEffect } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Container, Paper, Typography } from "@material-ui/core";
import TextFieldSignup from "./signupTextfield";
import Colors from "../../Global/colors";
import "./signup.css";
import background from "../../Assets/background.jpg";
import leftBackground from "../../Assets/left_background.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Redirect } from "react-router";
import apple from "../../Assets/apple_store.png";
import google from "../../Assets/Google_play.png";
import web from "../../Assets/web_apps.png";
import {useTranslation} from 'react-i18next';
import {useSelector , useDispatch} from 'react-redux';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

function Signup(props) {
  const classes = useStyles();
  let {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  
  useEffect(() => {
       console.log("{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{history}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}}",props);
    return () => props.func();
  }, []);


  if (localStorage.getItem("UserData") !== null) {
    return <Redirect to={"/"} />;
  }
  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        minHeight: "100vh",
        overflow: "scroll",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "auto",
        overflow: "auto",
      }}
    >
      <div>

      {window.innerWidth > 700 && 
      <Paper
        className="mainBox"
        elevation={3}
        style={{ margin: "2%", overflow: "hidden" }}
      >
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            order={{ md: 2, lg: 1 }}
          >
            <div style={{ padding: 30 }}>
              <p
                style={{
                  color: Colors.globalColor8,
                  marginBottom: 0,
                  fontFamily: "Poppins",
                }}
              >
                {t("Start for Free")}
              </p>
              <h3
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  fontWeight: 1000,
                  fontSize: 25,
                }}
              >
                {" "}
                {t("Create Account")}
              </h3>
              <p style={{ marginTop: 0, marginBottom: 10, fontSize: 12 }}>
                {t("Create your account to get started")}
              </p>
              <br />
              <TextFieldSignup func={(e) => this.props.func()} />
              <br />
              <Typography variant="p">
                {t("Existing user?")}{" "}
                <Link to="/signin" style={{ color: Colors.globalColor8 }}>
                  {t("Login")}
                </Link>
              </Typography>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            style={{
              padding: "30px 30px",
              backgroundImage: `url(${leftBackground})`,
              backgroundSize: "contain",
            }}
            order={{ md: 1, lg: 2 }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ flex: 1 }}>
              <Carousel interval={5000} autoPlay={true} infiniteLoop={true} showIndicators={false} showStatus={false} showArrows={false} style={{ backgroundColor: "green", paddingRight: "10%" }}>
              <div style={{ textAlign:language =="ar" ? "right" : "left" }}>
                      <p className="subTitle">
                      {t("Paperless inspections, audits, custom reports, detail dashboards and team collaborations from anywhere and anytime.")}
                      </p>
                      <h3 className="title">
                        {t("Digital Platform Unlimited Possibilities")}
                      </h3>
                    </div>
                    <div style={{ textAlign:language =="ar" ? "right" : "left" }}>
                      <p className="subTitle">
                        {t("Empowering real-time visibility with a simple interface, smart operations and initiative functions.")}
                      </p>
                      <h3 className="title">{t("Start Saving Time and Money")}</h3>
                    </div>
                    <div style={{ textAlign:language =="ar" ? "right" : "left" }}>
                      <p className="subTitle">
                        {t("Detect, manage and avoid potential risks with multiple pictures and videos evidences.")}
                      </p>
                      <h3 className="title">{t("Enterprise Risk Management")}</h3>
                    </div>
                  </Carousel>
              </div>

              <div
                style={{
                  flex: 1,
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                <p className="avaliblity">{t("Available On")}</p>
                <Grid
                  container
                  spacing={1}
                  alignItems="flex-start"
                  justify="flex-start"
                >
                  <Grid item>
                    <a href="https://play.google.com/store/apps/details?id=com.uraudit" target="blank">
                      <img src={google} width={50} />
                    </a>
                    <p className="avaliblity_item">
                      Google Play
                    </p>
                  </Grid>
                  <Grid item>
                    <a href="https://apps.apple.com/gb/app/uraudits/id1537135664" target="blank">
                      <img src={apple} width={50} />
                    </a>
                    <p className="avaliblity_item">
                      Apple Store
                    </p>
                  </Grid>
                  <Grid item>
                    <a href="/" target="blank">
                      <img src={web} width={50} />
                    </a>
                    <p className="avaliblity_item">
                      Web Apps
                    </p>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </Paper>}

      {window.innerWidth <= 700 && 
      <>
  
      <Paper
        className="mainBox"
        elevation={3}
        style={{ margin: "2%", overflow: "hidden" }}
      >
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
          >
            <div style={{ padding: 30 }}>
              <p
                style={{
                  color: Colors.globalColor8,
                  marginBottom: 0,
                  fontFamily: "Poppins",
                }}
              >
                {t("Start for Free")}
              </p>
              <h3
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  fontWeight: 1000,
                  fontSize: 25,
                }}
              >
                {" "}
                {t("Create Account")}
              </h3>
              <p style={{ marginTop: 0, marginBottom: 10, fontSize: 12 }}>
                {t("Create your account to get started")}
              </p>
              <br />
              <TextFieldSignup func={(e) => this.props.func()} />
              <br />
              <Typography variant="p">
                {t("Existing user?")}{" "}
                <Link to="/signin" style={{ color: Colors.globalColor8 }}>
                  {t("Login")}
                </Link>
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Paper>
      </>}


      {window.innerWidth > 500 && 
      <p className="copyright" >{t("Copyright 2022 UrAudits.com All Rights Reserved")}</p>
}


 {window.innerWidth <= 500 && 
      <p className="copyright2" >{t("Copyright 2022 UrAudits.com All Rights Reserved")}</p>
}     
      
      
      
      </div>
    </div>
  );
}
export default Signup;
